import { LOCATIONS } from '@locales/id/locations';
import { HUB, type LocationType } from '@lib/api';
import { num } from '@lib/format';

/** The types that belong under a parent in the distribution network (without one they are "Di luar jaringan"). */
const NEEDS_PARENT: readonly LocationType[] = [HUB];

/** A hub without its SPBG (= the backend's `status=off_network`; the database refuses one since 0030). */
export const isOffNetwork = (l: { type: string; parentLocationId?: number | null }) => NEEDS_PARENT.includes(l.type as LocationType) && l.parentLocationId == null;

/** Readers placed here, some of them not connected (= `status=reader_offline`). */
export const readersDown = (l: { gateways: number; gatewaysOnline: number }) => l.gateways > 0 && l.gatewaysOnline < l.gateways;

/**
 * A hub's ready-to-deliver stock in a few quiet words ("isi 12 · kosong 3"), when the server counts full and empty
 * (an older backend does not); null for other types and an empty stock.
 */
export const fillLine = (l: { type: string; stock: number; stockFull?: number; stockEmpty?: number }) =>
  l.type === HUB && l.stock > 0 && l.stockFull != null && l.stockEmpty != null ? LOCATIONS.fill(num(l.stockFull), num(l.stockEmpty)) : null;
